var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`input ${_vm.focused ? 'focus' : ''}`,on:{"mousedown":function($event){return _vm.onClick()}}},[_c('p',{on:{"mouseup":_vm.onMouseUp}},[_vm._v(_vm._s(_vm.content || '‌'))]),_c('div',{staticClass:"cursor",style:(`left: calc(0.5rem + ${_vm.cursorXOffset}px);`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }